import axios from 'axios';

const initialState = () => ({
  categories: [],
  batterieCertificateCategory: null,
  countsByCategory: {
    templates: 0,
    documents: 0,
  },
});

export const mutations = {
  SET_DOCUMENT_TEMPLATE_CATEGORIES(state, categories) {
    state.categories = categories;
  },

  SET_BATTERIE_CERTIFICATE_CATEGORY(state, category) {
    state.batterieCertificateCategory = category;
  },

  SET_COUNT_BY_CATEGORY(state, { type, count }) {
    state.countsByCategory[type] = count;
  },
};

let fetchPromise = null;
let batterieCertificateCategoryPromise = null;

export const actions = {
  async getBatterieCertificateCategory({ commit, state }) {
    if (state.batterieCertificateCategory) return state.batterieCertificateCategory;
    if (batterieCertificateCategoryPromise) return batterieCertificateCategoryPromise;

    batterieCertificateCategoryPromise = axios.get('/v2/documentCategory/batterieCertificate')
      .then((res) => {
        batterieCertificateCategoryPromise = null;
        commit('SET_BATTERIE_CERTIFICATE_CATEGORY', res.data.data);
        return res.data.data;
      });

    return batterieCertificateCategoryPromise;
  },

  async getDocumentCategories({ commit, state }, { forceReload = false } = {}) {
    if (!forceReload && fetchPromise) {
      return fetchPromise;
    }
    if (!forceReload && state.categories.length > 0) {
      return state.categories;
    }
    fetchPromise = axios.get('/v2/documentCategory')
      .then((res) => {
        fetchPromise = null;
        commit('SET_DOCUMENT_TEMPLATE_CATEGORIES', res.data.data);
        return res.data.data;
      });

    return fetchPromise;
  },

  createDocumentCategory({ dispatch }, category) {
    return axios.post('/v2/documentCategory/', { ...category, scope: 'user' }).then((createdCategory) => {
      dispatch('getDocumentCategories', { forceReload: true });
      dispatch('documentTable/notifyTables', {}, { root: true });
      dispatch('documentTemplateTable/notifyTables', {}, { root: true });
      return createdCategory.data.data;
    });
  },

  updateDocumentCategory({ dispatch }, category) {
    return axios.put(`/v2/documentCategory/${category.ID}`, { ...category, scope: 'user' }).then((updatedCategory) => {
      dispatch('getDocumentCategories', { forceReload: true });
      dispatch('documentTable/notifyTables', {}, { root: true });
      dispatch('documentTemplateTable/notifyTables', {}, { root: true });
      return updatedCategory.data.data;
    });
  },

  deleteDocumentCategory({ dispatch }, category) {
    return axios.delete(`/v2/documentCategory/${category.ID}`)
      .then(() => {
        dispatch('getDocumentCategories', { forceReload: true });
        dispatch('documentTable/notifyTables', {}, { root: true });
        dispatch('documentTemplateTable/notifyTables', {}, { root: true });
      });
  },

  getCountsByCategory({ dispatch }, categoryId) {
    return Promise.all([
      dispatch('getDocumentsCount', categoryId),
      dispatch('getTemplatesCount', categoryId),
    ]);
  },

  getDocumentsCount({ commit }, categoryId) {
    return axios.get('/v2/document/count', {
      params: { filter: { categoryId } },
    })
      .then(count => commit('SET_COUNT_BY_CATEGORY', { type: 'documents', count: count.data.data }));
  },

  getTemplatesCount({ commit }, categoryId) {
    return axios.get('/v2/documentTemplate/count', {
      params: { filter: { categoryId } },
    })
      .then(count => commit('SET_COUNT_BY_CATEGORY', { type: 'templates', count: count.data.data }));
  },

};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
};
